import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { Box, Button, Flex, Text } from '@mantine/core'
import { useClickOutside } from '@mantine/hooks'
import React from 'react'

import { useAnalytics } from '@flecto/analytics'
import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'
import DropdownItem from '@flecto/ui/lib/ui/molecules/DropdownItem'

import { type ScheduleControls as ScheduleControlsType } from '../../types/ScheduleControls'
import classes from './styles.module.css'

export function ScheduleControls({
  nextDate,
  previousDate,
  today,
  template = 'schedule',
}: ScheduleControlsType) {
  const { t: tt } = useTranslation('saas', { keyPrefix: 'schedule' })
  const track = useAnalytics('segment')
  const isSelectorActive = false
  const scheduleTemplate = [
    {
      label: tt('monthly'),
      value: 'monthly',
    },
    {
      label: tt('hourly'),
      value: 'hourly',
    },
  ]

  const [currentScheduleTemplate, setCurrentScheduleTemplate] = React.useState(
    scheduleTemplate[0]
  )
  const [isDropdownOpen, setDropdownOpen] = React.useState(false)
  const options = React.useMemo(
    () =>
      scheduleTemplate.filter(
        (item) => item.value !== currentScheduleTemplate.value
      ),
    [currentScheduleTemplate]
  )
  const ref = useClickOutside(() => setDropdownOpen(false))

  const handleCallback = (method: () => void, action: string) => {
    method()
    track('SCHEDULE__ACTION', { action })
  }

  return (
    <Flex justify='space-bewteen' gap='md'>
      {template === 'timeline' && isSelectorActive && (
        <Flex gap='xs'>
          <Button
            onClick={() => setDropdownOpen(!isDropdownOpen)}
            variant='secondary-neutral'
            rightSection={<Icon icon={faChevronDown} />}
          >
            {currentScheduleTemplate.label}
          </Button>
          {isDropdownOpen && (
            <Box className={classes.drpodown} ref={ref}>
              {options.map((option, key) => (
                <DropdownItem
                  key={key}
                  onClick={() => {
                    setCurrentScheduleTemplate(option)
                    setDropdownOpen(!isDropdownOpen)
                  }}
                >
                  <Text>{option.label}</Text>
                </DropdownItem>
              ))}
            </Box>
          )}
        </Flex>
      )}

      <Flex gap='xs'>
        <Button
          onClick={() => handleCallback(previousDate.onClick, 'previous')}
          variant='default'
        >
          {previousDate.label}
        </Button>
        <Button
          onClick={() => handleCallback(today.onClick, 'today')}
          variant='default'
        >
          {today.label}
        </Button>
        <Button
          onClick={() => handleCallback(nextDate.onClick, 'next')}
          variant='default'
        >
          {nextDate.label}
        </Button>
      </Flex>
    </Flex>
  )
}
